/*
 * Public API Surface of bn-ng-idle
 */

export * from './lib/bn-ng-idle.service';
export * from './lib/bn-ng-idle.module';
